export const testLunchrUrl = 'https://www.lunchr.co/testez-lunchr'
